import React, { createContext, useReducer } from 'react';

export const UPDATE_KIOSK = 'UPDATE_KIOSK';
export const IS_LOADING = 'IS_LOADING';
export const CLEAR = 'CLEAR';

const initialState = {
  isLoading: false,
  isFetched: false,
  connectionOk: true,
  kiosk: undefined,
  error: undefined,
};

const kioskContext = createContext(initialState);

const reducer = (state, action) => {
  switch (action.type) {
  case UPDATE_KIOSK: {
    return { ...state, ...action.payload };
  }
  case IS_LOADING: {
    return { ...state, ...{ isLoading: action.payload } };
  }
  case CLEAR: {
    return initialState;
  }
  default: {
    throw new Error('No matching kiosk action');
  }
  }
};

const KioskProvider = ( { children } ) => {
  const [ state, dispatch ] = useReducer(reducer, initialState);
  return <kioskContext.Provider value={{ kioskState: state, dispatch }}>{children}</kioskContext.Provider>;
};

export { kioskContext, KioskProvider };
